module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "insurance-table",
      "title": "Insurance",
      "icon": "fa fa-shield-alt",
      "hide-org-badge": "",
      "show-search": false,
      "url": '/insurance/site/' + _vm.rowData.id,
      "fields": _vm.fields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dddafb5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/calendar/Insurance.vue
// module id = 1626
// module chunks = 0